// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3Xcxx","row":"Node_row__26gOc","label":"Node_label__wUp6b","footer":"Node_footer__3HwPD"};